<template>
    <div class="h-screen w-screen flex items-center justify-center">

        <div class="flex items-center gap-2">
            <iconAlert iconClasses="h-[100px] w-[100px] text-green-500" />
            <div>
                <div class="font-blinker text-4xl">Opss!</div>
                <div class="font-blinker">Você deveria acessar essa página?</div>
                <div class="text-xs">Se sim, consulte seu administrador.</div>
            </div>
        </div>

    </div>


</template>